import { useEffect, useState } from 'react';
import { excelToolExecutor } from '../services/excel/ExcelToolExecutor';

/** Live view of the user's current Excel selection (sheet + A1 address, multi-area as "A1,C3") —
 *  shown as a chip in the chat so they can see what "this cell" will refer to. Seeds with the
 *  current selection, then follows the workbook's onSelectionChanged event with a polling fallback
 *  (see ExcelToolExecutor.onSelectionChanged); the watcher is disposed on unmount. */
export function useExcelSelection(): { sheet: string; address: string } | null {
  const [selection, setSelection] = useState<{ sheet: string; address: string } | null>(null);

  useEffect(() => {
    let cancelled = false;
    let dispose: (() => void) | null = null;
    void excelToolExecutor.readSelectionAddress().then((sel) => {
      if (!cancelled && sel) setSelection(sel);
    });
    void excelToolExecutor
      .onSelectionChanged((sel) => {
        if (!cancelled) setSelection(sel);
      })
      .then((d) => {
        if (cancelled) d();
        else dispose = d;
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
      dispose?.();
    };
  }, []);

  return selection;
}
